import { ArcherContainer, ArcherElement } from "react-archer";
import { HiBuildingOffice2, HiUser, HiGlobeAmericas } from "react-icons/hi2";

export const SharedWithUser: React.FC<{ resource: string }> = ({
  resource,
}) => (
  <div className="flex justify-center">
    <ArcherContainer strokeColor="black">
      <div className="w-fit p-10 flex flex-col space-y-32 items-center">
        <div className="">
          <ArcherElement
            id={"User"}
            relations={[
              {
                order: 2,
                targetId: "resource",
                targetAnchor: "top",
                sourceAnchor: "bottom",
                style: {
                  strokeColor: "orange",
                  strokeDasharray: "5,5",
                  endMarker: false,
                },
                label: (
                  <div className="bg-white whitespace-nowrap text-orange-400 rounded-full px-2">
                    has direct access to
                  </div>
                ),
              },
            ]}
          >
            <div className="flex items-center space-x-2 px-4 py-2 border border-orange-400 rounded-full bg-white">
              <HiUser />
              <div>User</div>
            </div>
          </ArcherElement>
        </div>

        <div className="">
          <ArcherElement id="resource">
            <div className="flex items-center space-x-2 px-4 py-2 border border-orange-400 rounded bg-white">
              <div>{resource} shared directly with them</div>
            </div>
          </ArcherElement>
        </div>
      </div>
    </ArcherContainer>
  </div>
);

export const SharedWithPublic: React.FC<{ resource: string }> = ({
  resource,
}) => (
  <div className="flex justify-center">
    <ArcherContainer strokeColor="black">
      <div className="w-fit p-10 flex flex-col space-y-32 items-center">
        <div className="">
          <ArcherElement
            id={"Everyone"}
            relations={[
              {
                order: 2,
                targetId: "resource",
                targetAnchor: "top",
                sourceAnchor: "bottom",
                style: {
                  strokeColor: "orange",
                  strokeDasharray: "5,5",
                  endMarker: false,
                },
                label: (
                  <div className="bg-white whitespace-nowrap text-orange-400 rounded-full px-2">
                    has direct access to
                  </div>
                ),
              },
            ]}
          >
            <div className="flex items-center space-x-2 px-4 py-2 border border-orange-400 rounded-full bg-white">
              <HiGlobeAmericas />
              <div>Everyone</div>
            </div>
          </ArcherElement>
        </div>

        <div className="">
          <ArcherElement id="resource">
            <div className="flex items-center space-x-2 px-4 py-2 border border-orange-400 rounded bg-white">
              <div>Public {resource}</div>
            </div>
          </ArcherElement>
        </div>
      </div>
    </ArcherContainer>
  </div>
);

export const SharedWithParent: React.FC<{ parent: string; child: string }> = ({
  parent,
  child,
}) => (
  <div className="flex justify-center">
    <ArcherContainer strokeColor="black">
      <div className="w-fit p-10 flex flex-col space-y-32 items-center">
        <div className="">
          <ArcherElement
            id={"User"}
            relations={[
              {
                order: 2,
                targetId: "parent",
                targetAnchor: "top",
                sourceAnchor: "bottom",
                style: { endMarker: false },
                label: (
                  <div className="bg-white whitespace-nowrap rounded-full px-2">
                    has direct access to
                  </div>
                ),
              },
              {
                order: 1,
                targetId: "InheritsAccessTo",
                targetAnchor: "top",
                sourceAnchor: "left",
                style: {
                  strokeColor: "orange",
                  strokeDasharray: "5,5",
                  lineStyle: "curve",
                  endMarker: false,
                },
              },
            ]}
          >
            <div className="flex items-center space-x-2 px-4 py-2 border border-orange-400 rounded-full bg-white">
              <HiUser />
              <div>User</div>
            </div>
          </ArcherElement>
        </div>

        <div className="w-full flex justify-between">
          <ArcherElement
            id="InheritsAccessTo"
            relations={[
              {
                targetId: "child",
                targetAnchor: "left",
                sourceAnchor: "bottom",
                style: {
                  strokeColor: "orange",
                  strokeDasharray: "5,5",
                  endMarker: false,
                },
              },
            ]}
          >
            <div className="px-8 py-2 text-orange-400 whitespace-nowrap">
              inherits access to
            </div>
          </ArcherElement>
          <ArcherElement
            id="parent"
            relations={[
              {
                targetId: "child",
                targetAnchor: "top",
                sourceAnchor: "bottom",
                style: { strokeWidth: 3 },
                label: (
                  <div className="bg-white whitespace-nowrap rounded-full px-2">
                    is a parent of
                  </div>
                ),
              },
            ]}
          >
            <div className="flex items-center space-x-2 px-4 py-2 border border-black rounded bg-white">
              <HiBuildingOffice2 />
              <div>{parent}</div>
            </div>
          </ArcherElement>
        </div>

        <div className="">
          <ArcherElement id="child">
            <div className="flex items-center space-x-2 px-4 py-2 border border-orange-400 rounded bg-white">
              <div>{child}</div>
            </div>
          </ArcherElement>
        </div>
      </div>
    </ArcherContainer>
  </div>
);
